// A modal owns only its temporary locks. Restore previous values/attributes on
// teardown instead of globally enabling scroll or resetting unrelated styles.
export function mountForumDialog(root, requestClose, previousFocus) {
  const doc = root.ownerDocument, win = doc.defaultView, records = [], styles = [];
  for (let current = root; current.parentElement; current = current.parentElement) {
    Array.from(current.parentElement.children).filter(node => node !== current && !['SCRIPT', 'STYLE', 'LINK'].includes(node.tagName)).forEach(node => {
      records.push({ node, inert: node.getAttribute('inert'), hidden: node.getAttribute('aria-hidden') });
      node.setAttribute('inert', ''); node.setAttribute('aria-hidden', 'true');
    });
    if (current.parentElement === doc.body) break;
  }
  // Lock the actual document scroller only. Giving body overflow:hidden also
  // creates a new sticky containing block and moves the topbar after scrolling.
  [doc.scrollingElement || doc.documentElement].forEach(node => {
    styles.push({ node, value: node.style.getPropertyValue('overflow'), priority: node.style.getPropertyPriority('overflow') });
    node.style.setProperty('overflow', 'hidden', 'important');
  });
  const focusable = () => Array.from(root.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(node => !node.hidden && node.getAttribute('tabindex') !== '-1' && !node.closest('[inert]'));
  function focusFirst() { const first = focusable()[0] || root; first.focus({ preventScroll: true }); }
  function keydown(event) {
    if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); requestClose(); }
    if (event.key !== 'Tab') return;
    const elements = focusable(), first = elements[0], last = elements[elements.length - 1];
    if (!first) { event.preventDefault(); root.focus(); return; }
    if (!root.contains(doc.activeElement) || event.shiftKey && (doc.activeElement === first || doc.activeElement === root)) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && doc.activeElement === last) { event.preventDefault(); first.focus(); }
  }
  function focusin(event) { if (!root.contains(event.target)) focusFirst(); }
  function resize() {
    const viewport = win.visualViewport;
    const topbar = doc.querySelector('.incremental-topbar');
    const headerBottom = topbar ? Math.max(0, topbar.getBoundingClientRect().bottom) : 62;
    const offset = viewport ? viewport.offsetTop : 0;
    const top = Math.max(headerBottom, offset);
    root.style.setProperty('--forum-dialog-top', top + 'px');
    root.style.setProperty('--forum-dialog-height', Math.max(0, (viewport ? viewport.height : win.innerHeight) + offset - top) + 'px');
  }
  doc.addEventListener('keydown', keydown); doc.addEventListener('focusin', focusin);
  win.addEventListener('resize', resize);
  if (win.visualViewport) { win.visualViewport.addEventListener('resize', resize); win.visualViewport.addEventListener('scroll', resize); }
  resize(); if (!root.contains(doc.activeElement)) focusFirst();
  return () => {
    doc.removeEventListener('keydown', keydown); doc.removeEventListener('focusin', focusin); win.removeEventListener('resize', resize);
    if (win.visualViewport) { win.visualViewport.removeEventListener('resize', resize); win.visualViewport.removeEventListener('scroll', resize); }
    records.forEach(({ node, inert, hidden }) => {
      if (inert === null) node.removeAttribute('inert'); else node.setAttribute('inert', inert);
      if (hidden === null) node.removeAttribute('aria-hidden'); else node.setAttribute('aria-hidden', hidden);
    });
    styles.forEach(({ node, value, priority }) => { if (value) node.style.setProperty('overflow', value, priority); else node.style.removeProperty('overflow'); });
    if (previousFocus && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
  };
}
